import { enumXMLType } from "../constants";
import { QXMLDoc } from "../CoreApp/QXMLDoc";
import { QXMLDocShape } from "../CoreApp/QXMLDocShape";

export function XML_CreateDoc(width, height, docType) {
  var xmlDoc;
  var scaleFactor;

  if (docType == enumXMLType.PDF) {
    xmlDoc = new QXMLDoc();
    scaleFactor = 0.75;
  } else {
    xmlDoc = new QXMLDocShape();
    scaleFactor = 1.0;
  }

  xmlDoc.InitXMLDoc(width, height, scaleFactor, docType);

  return xmlDoc;
}
